
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class CustomerRequirementItemsGrid extends _Ext.GridBase<CustomerRequirementItemsRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.CustomerRequirementItems'; }
        protected getDialogType() { return CustomerRequirementItemsDialog; }
        protected getIdProperty() { return CustomerRequirementItemsRow.idProperty; }
        protected getInsertPermission() { return CustomerRequirementItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomerRequirementItemsRow.localTextPrefix; }
        protected getService() { return CustomerRequirementItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }

        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(101);
            var userDefinition = Q.Authorization.userDefinition;
            var refno = FormatHelper.GetFormats("RefNo");
            //this.form.RefNo.value = refno;
            //let refno = "";
            //Common.CommonService.GetNextNumbers({ Prefix: 'C51000_', Length: 10 }, response => {
            //    if (response != null) {
            //        refno = response.Serial;
            //    }
            //}, { async: false });
            this.editItem(<CustomerRequirementItemsRow>{
                VoucherTypeId: 101,
                UserId: userDefinition.UserId,
                Iteration: "01",
                RefNo: refno
            });
        }
    }
}